"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7028],{

/***/ 97028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ benefits; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(46572);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/atoms/container/index.ts + 1 modules
var container = __webpack_require__(82112);
// EXTERNAL MODULE: ./components/atoms/section-text/index.ts
var section_text = __webpack_require__(67526);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(60825);
// EXTERNAL MODULE: ./components/atoms/link/index.ts + 1 modules
var atoms_link = __webpack_require__(27594);
// EXTERNAL MODULE: ./components/atoms/caption/index.ts + 1 modules
var atoms_caption = __webpack_require__(38959);
// EXTERNAL MODULE: ./components/molecules/swiper-custom/index.ts + 1 modules
var swiper_custom = __webpack_require__(6306);
// EXTERNAL MODULE: ./components/molecules/card/index.ts + 1 modules
var card = __webpack_require__(25649);
;// CONCATENATED MODULE: ./components/organisms/benefits/Benefits.tsx






/**
 * Benefits2
 */ var Benefits = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, Cards = param.Cards, desc = param.desc, title = param.title, caption = param.caption, variant = param.variant, backgroundColorTop = param.backgroundColorTop, backgroundColorBottom = param.backgroundColorBottom, _cutLevel = param.cutLevel, cutLevel = _cutLevel === void 0 ? 50 : _cutLevel, _cutLevelMobile = param.cutLevelMobile, cutLevelMobile = _cutLevelMobile === void 0 ? 50 : _cutLevelMobile, backgroundColorTopMobile = param.backgroundColorTopMobile, backgroundColorBottomMobile = param.backgroundColorBottomMobile, index = param.index, id = param.id, hasCutLevel = param.hasCutLevel, link = param.link, button = param.button, landing = param.landing;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(container/* default */.Z, {
        id: id,
        index: index,
        backgroundColorTop: backgroundColorTop !== null && backgroundColorTop !== void 0 ? backgroundColorTop : "#fff",
        backgroundColorBottom: backgroundColorBottom !== null && backgroundColorBottom !== void 0 ? backgroundColorBottom : "#fff",
        cutLevel: cutLevel !== null && cutLevel !== void 0 ? cutLevel : 50,
        cutLevelMobile: cutLevelMobile !== null && cutLevelMobile !== void 0 ? cutLevelMobile : 50,
        backgroundColorBottomMobile: backgroundColorBottomMobile,
        backgroundColorTopMobile: backgroundColorTopMobile,
        className: "".concat(className, " flex flex-row gap-10 py-7 md:gap-14 md:py-10 lg:gap-20 lg:py-20"),
        overflows: true,
        hasCutLevel: hasCutLevel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex w-full flex-col gap-2 overflow-visible lg:flex-row lg:gap-20",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(section_text/* default */.Z, {
                            direction: "column",
                            textAlign: "start",
                            variant: variant,
                            title: title,
                            desc: desc,
                            caption: caption,
                            className: "!mb-0",
                            overflows: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden w-fit flex-col gap-6 pt-12 lg:flex",
                            children: [
                                button && button.label && button.variant && button.src && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                    size: "large",
                                    variant: button.variant,
                                    children: button.label
                                }),
                                link && link.src && link.label && link.variant && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: link.src,
                                    "aria-label": link.label,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                        arrow: true,
                                        variant: link.variant,
                                        "aria-label": link.label,
                                        children: link.label
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:ml-0 lg:w-[66%] lg:max-w-[66%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_custom["default"], {
                        direction: "row",
                        scrollbar: true,
                        navigation: true,
                        slidesPerView: 2.6,
                        slidesPerViewTablet: 3.1,
                        slidesPerViewMobile: 1.2,
                        gap: 16,
                        overflows: true,
                        avoidOverflowLeft: "apartments" === "apartments",
                        children: Cards.map(function(child, index) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(card/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                className: "!h-full md:ml-0",
                                classNames: {
                                    content: "flex flex-col justify-between gap-4"
                                }
                            }, child.cardProps), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-4 ".concat( true && child.cardProps.backgroundColor && child.cardProps.backgroundColor !== "surface-00" ? "text-black" : "text-text-primary"),
                                        children: [
                                            child.cardCaption && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_caption/* default */.Z, {
                                                className: "mb-[-10px] !text-[10px]",
                                                hasDecoration: false,
                                                children: child.cardCaption
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className:  true ? "text-[18px] font-light tracking-[-0.005em]" : 0,
                                                children: child.cardTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-body text-body--secondary font-light",
                                                children: child.cardDesc
                                            })
                                        ]
                                    }),
                                    !landing && ((ref = child.cardLink) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: child.cardLink.src,
                                        passHref: true,
                                        prefetch: false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                            variant:  true && child.cardProps.backgroundColor && child.cardProps.backgroundColor !== "surface-00" ? "tertiary" : variant,
                                            underline: true,
                                            children: child.cardLink.label
                                        })
                                    })
                                ]
                            }), index);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center pb-8 pt-4 lg:hidden",
                    children: [
                        button && button.label && button.variant && button.src && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            className: "mb-6",
                            size: "large",
                            variant: button.variant,
                            children: button.label
                        }),
                        link && link.src && link.label && link.variant && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: link.src,
                            "aria-label": link.label,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* default */.Z, {
                                arrow: true,
                                variant: link.variant,
                                "aria-label": link.label,
                                children: link.label
                            })
                        })
                    ]
                })
            ]
        })
    });
};
Benefits.displayName = "Benefits";

;// CONCATENATED MODULE: ./components/organisms/benefits/index.ts

/* harmony default export */ var benefits = (Benefits);


/***/ })

}]);